import Notification from "components/Notification.vue";
import TwNotification from "components/TwNotification.vue";
const NotificationPlugin = {
    install(Vue) {
        Vue.prototype.$notify = function (options) {
            if (!this.$_notificationInstance) {
                this.$enableNotifications(options.theme);
                if (!this.$_notificationInstance) {
                    console.error("NotificationPluginError: Error encountered initializing Notification component.");
                    return;
                }
            }
            // Hide the previous notification first and then
            // invoke it again.
            if (this.$_notificationInstance.show) {
                if (this.$_notificationTimeoutHandler) {
                    clearTimeout(this.$_notificationTimeoutHandler);
                }
                this.$_notificationInstance.show = false;
                this.$_notificationTimeoutHandler = setTimeout(() => {
                    this.$notify(options);
                }, 500);
                return;
            }
            this.$_notificationInstance.show = true;
            this.$_notificationInstance.title = options.title || "";
            this.$_notificationInstance.message = options.message;
            this.$_notificationInstance.status = options.status || "primary";
            if (this.$_notificationTimeoutHandler) {
                clearTimeout(this.$_notificationTimeoutHandler);
            }
            let notificationTimeout = this.$_notificationTimeout;
            if (options.timeout) {
                notificationTimeout = options.timeout;
            }
            if (notificationTimeout > 0 && !options.sticky) {
                this.$_notificationTimeoutHandler = setTimeout(() => {
                    this.$_notificationInstance.show = false;
                    this.$_notificationInstance.title = "";
                    this.$_notificationInstance.message = "";
                    this.$_notificationInstance.status = "success";
                }, notificationTimeout);
            }
        };
        Vue.prototype.$setNotificationTimeout = function (timeout) {
            timeout = parseInt(timeout);
            timeout = isNaN(timeout) ? 0 : timeout;
            this.$_notficationTimeout = timeout;
        };
        Vue.prototype.$enableNotifications = function (theme = '') {
            const componentConstructor = theme === 'tailwind'
                ? Vue.extend(TwNotification)
                : Vue.extend(Notification);
            const instance = new componentConstructor({
                propsData: {
                    show: false,
                    title: "test",
                    message: "",
                }
            });
            instance.$mount();
            this.$el.appendChild(instance.$el);
            this.$_notificationInstance = instance;
            this.$_notficationTimeout = 8000;
            return instance;
        };
    }
};
export default NotificationPlugin;
